export const AppRoute = {
    Root:
        "/",
    Dashboard:
        "/dashboard",
    Dashboard2:
        "/dashboard2",
    BukkuAI:
        "/bukku-ai",
    Financing:
        "/financing-portal",
    Sales:
        "/sales",
    SalesQuotations:
        "/sales/quotes",
    SalesQuotationsNew:
        "/sales/quotes/new",
    SalesQuotationsBatch:
        "/sales/quotes/batch",
    SalesQuotationsView:
        "/sales/quotes/:id",
    SalesOrders:
        "/sales/orders",
    SalesOrdersNew:
        "/sales/orders/new",
    SalesOrdersBatch:
        "/sales/orders/batch",
    SalesOrdersView:
        "/sales/orders/:id",
    SalesDeliveryOrders:
        "/sales/delivery-orders",
    SalesDeliveryOrdersNew:
        "/sales/delivery-orders/new",
    SalesDeliveryOrdersView:
        "/sales/delivery-orders/:id",
    SalesDeliveryOrdersBatch:
        "/sales/delivery-orders/batch",
    SalesInvoices:
        "/sales/invoices",
    SalesInvoicesNew:
        "/sales/invoices/new",
    SalesInvoicesBatch:
        "/sales/invoices/batch",
    SalesInvoicesBatchCash:
        "/sales/invoices/batch-cash",
    SalesInvoicesView:
        "/sales/invoices/:id",
    SalesCreditNotes:
        "/sales/credit-notes",
    SalesCreditNotesNew:
        "/sales/credit-notes/new",
    SalesCreditNotesBatch:
        "/sales/credit-notes/batch",
    SalesCreditNotesView:
        "/sales/credit-notes/:id",
    SalesPayments:
        "/sales/payments",
    SalesPaymentsNew:
        "/sales/payments/new",
    SalesPaymentsModeView:
        "/sales/payments/:mode/:id",
    SalesPaymentsBatch:
        "/sales/payments/batch",
    SalesPaymentsView:
        "/sales/payments/:id",
    SalesRefunds:
        "/sales/refunds",
    SalesRefundsNew:
        "/sales/refunds/new",
    SalesRefundsBatch:
        "/sales/refunds/batch",
    SalesRefundsView:
        "/sales/refunds/:id",
    SalesOpeningInvoicesView:
        "/sales/opening-invoices/:id",
    SalesOpeningCreditNotesView:
        "/sales/opening-credit-notes/:id",
    Purchases:
        "/purchases",
    PurchasesOrders:
        "/purchases/orders",
    PurchasesOrdersNew:
        "/purchases/orders/new",
    PurchasesOrdersBatch:
        "/purchases/orders/batch",
    PurchasesOrdersView:
        "/purchases/orders/:id",
    PurchasesGoodsReceivedNotes:
        "/purchases/goods-received-notes",
    PurchasesGoodsReceivedNotesNew:
        "/purchases/goods-received-notes/new",
    PurchasesGoodsReceivedNotesView:
        "/purchases/goods-received-notes/:id",
    PurchasesBills:
        "/purchases/bills",
    PurchasesBillsNew:
        "/purchases/bills/new",
    PurchasesBillsBatch:
        "/purchases/bills/batch",
    PurchasesBillsBatchCash:
        "/purchases/bills/batch-cash",
    PurchasesBillsBatchExpenseClaims:
        "/purchases/bills/batch-expense-claims",
    PurchasesBillsView:
        "/purchases/bills/:id",
    PurchasesCreditNotes:
        "/purchases/credit-notes",
    PurchasesCreditNotesNew:
        "/purchases/credit-notes/new",
    PurchasesCreditNotesBatch:
        "/purchases/credit-notes/batch",
    PurchasesCreditNotesView:
        "/purchases/credit-notes/:id",
    PurchasesPayments:
        "/purchases/payments",
    PurchasesPaymentsNew:
        "/purchases/payments/new",
    PurchasesPaymentsBatch:
        "/purchases/payments/batch",
    PurchasesPaymentsModeView:
        "/purchases/payments/:mode/:id",
    PurchasesPaymentsView:
        "/purchases/payments/:id",
    PurchasesRefunds:
        "/purchases/refunds",
    PurchasesRefundsNew:
        "/purchases/refunds/new",
    PurchasesRefundsView:
        "/purchases/refunds/:id",
    PurchasesOpeningBillsView:
        "/purchases/opening-bills/:id",
    PurchasesOpeningCreditNotesView:
        "/purchases/opening-credit-notes/:id",
    Shoebox:
        "/shoebox",
    Bank:
        "/bank",
    BankIncomes:
        "/bank/incomes",
    BankIncomesNew:
        "/bank/incomes/new",
    BankIncomesBatch:
        "/bank/incomes/batch",
    BankIncomesView:
        "/bank/incomes/:id",
    BankExpenses:
        "/bank/expenses",
    BankExpensesNew:
        "/bank/expenses/new",
    BankExpensesBatch:
        "/bank/expenses/batch",
    BankExpensesView:
        "/bank/expenses/:id",
    BankTransfers:
        "/bank/transfers",
    BankTransfersNew:
        "/bank/transfers/new",
    BankTransfersView:
        "/bank/transfers/:id",
    BankAccounts:
        "/bank/accounts",
    BankAccountsNew:
        "/bank/accounts/new",
    BankAccountsView:
        "/bank/accounts/:id",
    BankAccountsReconcile:
        "/bank/accounts/:accountId/reconcile",
    BankFeeds:
        "/bank/feeds",
    BankFeedTransactions:
        "/bank/feeds/:bankFeedId/accounts/:accountId/transactions",
    Contacts:
        "/contacts",
    ContactsNew:
        "/contacts/new",
    ContactsBatchUpdate:
        "/contacts/batch-update",
    ContactsImport:
        "/contacts/import",
    ContactsGroups:
        "/contacts/groups",
    ContactsGroupsNew:
        "/contacts/groups/new",
    ContactsGroupsView:
        "/contacts/groups/:id",
    ContactsStatement:
        "/contacts/statement",
    ContactsView:
        "/contacts/:id",
    ContactsViewAuditLog:
        "/contacts/:id/logs/:logId",
    Products:
        "/products",
    ProductsItems:
        "/products/items",
    ProductsItemsNew:
        "/products/items/new",
    ProductsItemsBatchUpdate:
        "/products/items/batch-update",
    ProductsItemsImport:
        "/products/items/import",
    ProductsItemsView:
        "/products/items/:id",
    ProductsViewAuditLog:
        "/products/:id/logs/:logId",
    ProductsGroups:
        "/products/groups",
    ProductsGroupsNew:
        "/products/groups/new",
    ProductsGroupsView:
        "/products/groups/:id",
    ProductsBundles:
        "/products/bundles",
    ProductsBundlesNew:
        "/products/bundles/new",
    ProductsBundlesView:
        "/products/bundles/:id",
    StockAdjustments:
        "/stock/adjustments",
    StockAdjustmentsNew:
        "/stock/adjustments/new",
    StockAdjustmentsView:
        "/stock/adjustments/:id",
    StockTransfers:
        "/stock/transfers",
    StockTransfersNew:
        "/stock/transfers/new",
    StockTransfersView:
        "/stock/transfers/:id",
    StockValuesView:
        "/stock/values",
    MyInvoisDocuments:
        "/myinvois/documents",
    MyInvoisDocumentsView:
        "/myinvois/documents/:id",
    MyInvoisTransactions:
        "/myinvois/transactions",
    MyInvoisIncomingDocuments:
        "/myinvois/incoming-documents",
    MyInvoisBukkuMiniPos:
        "/myinvois/minipos",
    Reports:
        "/reports",
    ReportsAll:
        "/reports/all",
    ReportsBalanceSheet:
        "/reports/balance-sheet",
    ReportsProfitLoss:
        "/reports/profit-loss",
    ReportsCashFlow:
        "/reports/cash-flow",
    ReportsTrialBalance:
        "/reports/trial-balance",
    ReportsAgedReceivablesSummary:
        "/reports/aged-receivables/summary",
    ReportsAgedReceivablesDetail:
        "/reports/aged-receivables/detail",
    ReportsAgedPayablesSummary:
        "/reports/aged-payables/summary",
    ReportsAgedPayablesDetail:
        "/reports/aged-payables/detail",
    ReportsProductSalesSummary:
        "/reports/product-sales/summary",
    ReportsProductSalesDetail:
        "/reports/product-sales/detail",
    ReportsProductBundleSalesSummary:
        "/reports/product-bundle-sales/summary",
    ReportsProductPurchasesSummary:
        "/reports/product-purchases/summary",
    ReportsProductPurchasesDetail:
        "/reports/product-purchases/detail",
    ReportsItemSalesCollection:
        "/reports/item-sales-collection",
    ReportsTagSalesSummary:
        "/reports/tag-sales/summary",
    ReportsCustomerSalesSummary:
        "/reports/customer-sales/summary",
    ReportsGeneralLedger:
        "/reports/general-ledger",
    ReportsDebtorLedger:
        "/reports/debtor-ledger",
    ReportsCreditorLedger:
        "/reports/creditor-ledger",
    ReportsInvoiceSummary:
        "/reports/invoice-summary",
    ReportsCreditNoteSummary:
        "/reports/credit-note-summary",
    ReportsPurchaseCreditNoteSummary:
        "/reports/purchase-credit-note-summary",
    ReportsPaymentSummary:
        "/reports/payment-summary",
    ReportsPurchasePaymentSummary:
        "/reports/purchase-payment-summary",
    ReportsBillSummary:
        "/reports/bill-summary",
    ReportsBankReconciliation:
        "/reports/bank-reconciliation",
    ReportsReconciledTransactions:
        "/reports/reconciled-transactions",
    ReportsInventorySummary:
        "/reports/inventory/summary",
    ReportsInventoryDetail:
        "/reports/inventory/detail",
    ReportsInventorySummaryByLocation:
        "/reports/inventory-summary-by-location",
    ReportsProfitSummary:
        "/reports/profit-summary",
    ReportsProfitDetail:
        "/reports/profit-detail",
    ReportsCustomerQuotations:
        "/reports/customer-quotes",
    ReportsSupplierOrders:
        "/reports/supplier-orders",
    ReportsSupplierPurchasesSummary:
        "/reports/supplier-purchases/summary",
    ReportsCustomerSalesOrders:
        "/reports/customer-sales-orders",
    ReportsCustomerDeliveryOrders:
        "/reports/customer-delivery-orders",
    ReportsSst02:
        "/reports/sst-02",
    ReportsSstSalesDetail:
        "/reports/sst-sales-detail",
    ReportsSstPurchaseDetail:
        "/reports/sst-purchase-detail",
    ReportsSstPaymentCollection:
        "/reports/sst-payment-collection",
    ReportsSstDeemedPayments:
        "/reports/sst-deemed-payments",
    ReportsSstRecoveredPayments:
        "/reports/sst-recovered-payments",
    ReportsFixedAssets:
        "/reports/fixed-assets",
    ReportsSstPastPrepayments:
        "/reports/sst-past-prepayments",
    ReportsSstCurrentPrepayments:
        "/reports/sst-current-prepayments",
    ReportsSstByProducts:
        "/reports/sst-by-products",
    ReportsDepreciationSchedule:
        "/reports/depreciation-schedule",
    ReportsDisposalSchedule:
        "/reports/disposal-schedule",
    ReportsFinancialSummary:
        "/reports/financial-summary",
    ReportsForeignExchangeSummary:
        "/reports/foreign-exchange-summary",
    // ReportsForeignExchangeDetail:
    //     "/reports/foreign-exchange-detail",
    ReportsUnrealisedExchangeDetail:
        "/reports/unrealised-exchange-detail",
    ReportsExchangeRates:
        "/reports/exchange-rates",
    ReportsTransactionList:
        "/reports/transaction-list",
    ReportsAuditTrails:
        "/reports/audit-trails",
    ReportsPaymentVoucherSummary:
        "/reports/payment-voucher/summary",
    ReportsOfficialReceiptSummary:
        "/reports/official-receipt/summary",
    ReportsCashSalesSummary:
        "/reports/cash-sales/summary",
    ReportsCashPurchaseSummary:
        "/reports/cash-purchase/summary",
    ReportsJournalEntryDetail:
        "/reports/journal-entry-detail",
    ReportsDoubleEntryDetail:
        "/reports/double-entry-detail",
    ReportsChartOfAccounts:
        "/reports/chart-of-accounts",
    Accounting:
        "/accounting",
    AccountingJournalEntries:
        "/accounting/journal-entries",
    AccountingJournalEntriesNew:
        "/accounting/journal-entries/new",
    AccountingJournalEntriesBatch:
        "/accounting/journal-entries/batch",
    AccountingJournalEntriesPayroll:
        "/accounting/journal-entries/payroll",
    AccountingJournalEntriesView:
        "/accounting/journal-entries/:id",
    AccountingContras:
        "/accounting/contras",
    AccountingContrasNew:
        "/accounting/contras/new",
    AccountingContrasView:
        "/accounting/contras/:id",
    AccountingAccounts:
        "/accounting/accounts",
    AccountingAccountsNew:
        "/accounting/accounts/new",
    AccountingAccountsImport:
        "/accounting/accounts/import",
    AccountingAccountsOpeningBalance:
        "/accounting/accounts/opening-balance",
    AccountingAccountsView:
        "/accounting/accounts/:id",
    AccountingAccountsViewAuditLog:
        "/accounting/accounts/:id/logs/:logId",
    AccountingDeemedPayments:
        "/accounting/deemed-payments",
    AccountingDeemedPaymentsNew:
        "/accounting/deemed-payments/new",
    AccountingDeemedPaymentsView:
        "/accounting/deemed-payments/:id",
    AccountingAssets:
        "/accounting/assets",
    AccountingAssetsDepreciate:
        "/accounting/assets/depreciate",
    AccountingAssetsNew:
        "/accounting/assets/new",
    AccountingAssetsBatch:
        "/accounting/assets/batch",
    AccountingAssetsView:
        "/accounting/assets/:id",
    AccountingAssetsEdit:
        "/accounting/assets/:id/edit",
    AccountingAssetsDispose:
        "/accounting/assets/:id/dispose",
    ControlPanel:
        "/cp",
    Instructions:
        "/cp/instructions",
    InstructionsNew:
        "/cp/instructions/new",
    InstructionsView:
        "/cp/instructions/:id",
    FileManager:
        '/cp/files',
    Terms:
        "/cp/terms",
    TermsNew:
        "/cp/terms/new",
    TermsView:
        "/cp/terms/:id",
    Currencies:
        "/cp/currencies",
    CurrenciesCode:
        "/cp/currencies/:code",
    Tags:
        "/cp/tags",
    AssetTypes:
        "/cp/asset-types",
    AssetTypesNew:
        "/cp/asset-types/new",
    AssetTypesView:
        "/cp/asset-types/:id",
    Locations:
        "/cp/locations",
    LocationsNew:
        "/cp/locations/new",
    LocationsView:
        "/cp/locations/:id",
    Fields:
        "/cp/fields",
    FieldsNew:
        "/cp/fields/new",
    FieldsView:
        "/cp/fields/:id",
    PriceLevels:
        "/cp/price-levels",
    PaymentMethods:
        "/cp/payment-methods",
    FormDesigns:
        "/cp/form-designs",
    FormDesignsNew:
        "/cp/form-designs/new",
    FormDesignsView:
        "/cp/form-designs/:id",
    Profile:
        "/cp/profile",
    Settings:
        "/cp/settings",
    NumberFormats:
        "/cp/number-formats",
    ShoeboxSettings:
        "/cp/shoebox",
    Subscription:
        "/cp/subscription",
    Integrations:
        "/cp/integrations",
    BackupData:
        "/cp/backup-data",
    Users:
        "/cp/users",
    UsersNew:
        "/cp/users/new",
    UsersView:
        "/cp/users/:id",
    Apps:
        "/cp/apps",
    Store:
        "/cp-store",
    StoreOrders:
        "/cp-store/orders",
    StoreCategories:
        "/cp-store/categories",
    StoreCategoriesNew:
        "/cp-store/categories/new",
    StoreCategoriesRearrange:
        "/cp-store/categories/rearrange",
    StoreCategoriesView:
        "/cp-store/categories/:id",
    StorePages:
        "/cp-store/pages",
    StorePagesNew:
        "/cp-store/pages/new",
    StorePagesView:
        "/cp-store/pages/:id",
    StoreCoupons:
        "/cp-store/coupons",
    StoreCouponsNew:
        "/cp-store/coupons/new",
    StoreCouponsView:
        "/cp-store/coupons/:id",
    StoreSettings:
        "/cp-store/settings",

    Partners:
        "/partners",
    PartnersProfile:
        "/partners/profile",
    PartnersClients:
        "/partners/clients",
    PartnersClientsClientUsers:
        "/partners/clients/:clientId/users",
    PartnersClientsClientUsersNew:
        "/partners/clients/:clientId/users/new",
    PartnersClientsClientUsersView:
        "/partners/clients/:clientId/users/:id",
    PartnersClientsReferrals:
        "/partners/referrals",
    PartnersTransactions:
        "/partners/transactions",
    PartnersEventLogs:
        "/partners/logs",
    PartnersAdvisors:
        "/partners/advisors",
    PartnersAdvisorsNew:
        "/partners/advisors/new",
    PartnersAdvisorsView:
        "/partners/advisors/:id",
    PartnersBrandAssets:
        "/partners/brand-assets",
    ImportUbs:
        "/import/ubs",
    Annotate:
        "/annotate",
    Test:
        "/test",
    TestDnd:
        "/test/dnd",
    TestTodo:
        "/test/todo",
    TestLightgallery2:
        "/test/lightgallery2",
    TestLightgallery3:
        "/test/lightgallery3",
    TestLightgallery4:
        "/test/lightgallery4",
    TestLightgallery5:
        "/test/lightgallery5",
    TestLightgallery51:
        "/test/lightgallery5-1",
    TestLightgalleryPreview:
        "/test/lightgalleryPreview",
    TestFloatingWindow:
        "/test/floating-window",
    TestTransitionGroup:
        "/test/transition-group",
    TestPreviewInvoice:
        "/test/preview-billing-invoice",
    BukkuZoomPanel:
        "/test/zoompanel",

    Flow:
        "/cp/flow",
    FlowStreamSettingsView:
        "/cp/flow/streams/:id",
    FlowStreamMappingsView:
        "/cp/flow/streams/:id/mappings",
    FlowDigests:
        "flow/streams/:id/digests",
    FlowDigestsView:
        "flow/streams/:id/digests/:id2",

    MiniPos:
        "minipos",
    MiniPosSettings:
        "minipos/settings",
    MiniPosOrders:
        "minipos/orders",
    MiniPosOrdersView:
        "minipos/orders/:id",
    BukkuAdmin:
        "/bukkuadmin",
};
